import type { AnalyzerEntity, FindingParameters } from '@telespot/domain';
import { AssetStatusProjectionService, AssetStatusSummary } from '@analysis/domain';

import { type AssetStatusRepository } from '../../ports/asset-status.repository';
import { type RoiChangesRepository } from '../../ports/roi-changes.repository';

export interface GetAssetStatusPayload {
  sampleId: string;
  assetIds: string[];
  analystId: string;
  analystEntity: AnalyzerEntity;
  // TODO: persist finding state so this can be fetched via the repository like RoiChanges.
  localFindings: FindingParameters[];
}

export class GetAssetStatusUseCase {
  constructor(
    private readonly assetStatus: AssetStatusRepository,
    private readonly roiChanges: RoiChangesRepository
  ) {}

  public async execute(payload: GetAssetStatusPayload): Promise<AssetStatusSummary> {
    const baseline = await this.assetStatus.getAssetStatus({
      sampleId: payload.sampleId,
      assetIds: payload.assetIds,
      analystId: payload.analystId,
      analystEntity: payload.analystEntity,
    });

    const roiChanges = await this.roiChanges.getForSampleAndAnalyst(payload.sampleId, payload.analystId);

    return AssetStatusProjectionService.project(baseline, roiChanges, payload.localFindings, payload.analystId);
  }
}
